<template>
    <div class="home">
        <div class="container-fluid">
            <error-component
				v-if="exceptions.length > 0"
				v-bind="exceptions[0]">
			</error-component>
			<success-component
				v-if="success.length > 0"
				:message="success">
			</success-component>

            <div v-if="loading"><bouncing-loader /></div>

            <div v-else class="row">
                <div class="col-md-12 mb-4 ml-1 p-2" v-if="hasOrganization">
                    <h2 class="title">👋 Hi, Welcome!</h2>

                    <p v-if="!this.hasConnection && !this.hasQuery && !this.hasVisualization && !this.hasReport">
                        👩‍🏫 In order to start using Data Providers we will guide you step by step to setup and implement your first report.
                        <br />
                        Follow the guide below step by step. 👇
                    <p>

                    <p v-if="!this.hasConnection">
                        In order to start working with Data Providers you need to setup a database connection. Data Provider will
                        use the connection to pull data from your database using queries that you'll write. <br />
                        The supported databases are MYSQL, PostgreSQL, SQLServer, DB2, Oracle or others using ODBC. <br />
                        The database must be accesible via internet, it must be in the cloud.
                        <br />
                        <br />
                        <router-link :to="{ name: 'connection.create' }" id="connection">
                            <font-awesome-icon icon="database" style="width: 25px" /> Make your first connection
                        </router-link>
                    </p>

                    <p v-if="this.hasConnection && !this.hasQuery">
                        👩‍🏫 Now that you have a connection you need to create a query to pull the data from the connection. <br />
                        The query is an SQL query to be executed in your database server, you must use your Database dialect to write the query, once it's working and pulling data you can save it to use
                        the data into visualizations.
                        <br />
                        <br />
                        <router-link :to="{ name: 'query.create' }" id="query">
                            <font-awesome-icon icon="terminal" style="width: 25px" /> Write your first Query
                        </router-link>
                    </p>

                    <p v-if="this.hasConnection && this.hasQuery && !this.hasVisualization">
                        👩‍🏫 Using the query results you must create visualizations. <br />
                        We support different kinds of visualizations such as tables, numbers, pies, bars, chart.
                        <br />
                        <br />
                        <router-link :to="{ name: 'visualization.create' }" id="visualization">
                            <font-awesome-icon icon="chart-pie" style="width: 25px" /> Create a visualization
                        </router-link>
                    </p>

                    <p v-if="this.hasConnection && this.hasQuery && this.hasVisualization && !this.hasReport">
                        👩‍🏫 The last step on the onboarding, create a report to include visualizations and use the designer to present all the information that you need.<br />
                        The reports can be shared, exported, make them public to the internet and even embedded into another application.
                        <br />
                        <br />
                        <router-link :to="{ name: 'report.create' }" id="report">
                            <font-awesome-icon icon="file-alt" style="width: 25px" /> Create your first Report
                        </router-link>
                    </p>

                    <div v-if="this.hasConnection && this.hasQuery && this.hasVisualization && this.hasReport">
                       <p class="widget-title">Here is a list of what you have been doing so far 💡</p>
                       <div class="row">
                            <reports-widget />
                            <visualizations-widget />
                            <queries-widget />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ReportsWidget from './widgets/Reports.vue';
    import VisualizationsWidget from './widgets/Visualizations.vue';
    import QueriesWidget from './widgets/Queries.vue';
    import BouncingLoader from './Bouncing-loader.vue';
    import SuccessComponent from './Success.vue';
	import ErrorComponent from './ErrorView.vue';
    import { mapGetters, mapState } from 'vuex';

    export default {
        name: "Welcome",
        components: {
            BouncingLoader,
            ReportsWidget,
            VisualizationsWidget,
            QueriesWidget,
            SuccessComponent,
            ErrorComponent
        },
        computed: {
            ...mapGetters({
                organizations: 'getOrganizations',
                organizationSelected: 'getOrganizationSelected',
            }),
            ...mapState({
                exceptions: 'exceptions',
                success: 'success'
            })
        },
        mounted() {
            this.checkReport();
        },
        data() {
            return {
                hasConnection: false,
                hasQuery: false,
                hasVisualization: false,
                hasReport: false,
                hasOrganization: false,
                loading: true
            }
        },
        methods: {
            checkReport() {
                if (this.organizations.length > 0) {
                    this.hasOrganization = true;
                }

                if (this.organizations.length > 0 && this.$store.getters.getOrganizationSelected != -1) {
                    this.loading = true;
                    axios
                        .get('me/elements/' + this.$store.getters.getOrganizationSelected).then(res => {
                            this.hasConnection = res.data.data.elements.connection;
                            this.hasQuery = res.data.data.elements.query;
                            this.hasVisualization = res.data.data.elements.visualization;
                            this.hasReport = res.data.data.elements.report;
                            this.loading = false;
                        })
                        .catch((error) => {
                            this.loading = false;
                            throw new Error(`[RWV] ApiService`);
                        })
                }
            }
        },
        watch: {
            'organizations'(val) {
                this.checkReport();
            },
            'organizationSelected'(val) {
                this.checkReport();
            }
        },
    }
</script>

<style scoped>
    .title, .subtitle {
        font-family: 'Teko', sans-serif;
        font-size: 50px;
        margin-bottom: 10px;
    }

    .title {
        padding-left: 0px;
    }

    .subtitle {
        font-size: 25px;
    }

    li {
        font-size: 1.4rem;
    }

    li a:hover {
        text-decoration: none;
    }
    .welcomeheader {
        color: #fdfdff;
    }

    .home {
        font-size: 16px;
    }

</style>
